var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosePrimary60(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.723,
    height: 14.799,
    viewBox: "0 0 14.723 14.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-close",
    transform: "translate(0.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-add",
    transform: "translate(7.077 0.077) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5408\\u4F53_887",
    "data-name": "\\u5408\\u4F53 887",
    d: "M4.405,10.455V6.005H0V4.45H4.405V0H5.961V4.45h4.405V6.005H5.961v4.45Z",
    transform: "translate(0 0)",
    fill: "#788494"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePrimary60);
export default __webpack_public_path__ + "static/media/close-primary-60.fb1236aa3b246b402c79ef2a0060a9cd.svg";
export { ForwardRef as ReactComponent };